import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { myListsDetailsOptionsStyles } from "@dana/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

myListsDetailsOptionsStyles.sortByOverflowMenu = mergeToNew(myListsDetailsOptionsStyles.sortByOverflowMenu, {
    buttonProps: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;

            &:hover {
                background: transparent;
            }
        `,
    },
    mergeCss: true,
    cssOverrides: {
        menuItem: css`
            &:hover {
                background: ${themeColors.primary.danaBlue};
                color: ${themeColors.primary.white};
            }
        `,
    },
});

myListsDetailsOptionsStyles.uploadItemsModal = mergeToNew(myListsDetailsOptionsStyles.uploadItemsModal, {
  size: 1110,
});
